import { Abwesenheitsgrund } from '@/domain/arbeitszeiten/entities';
import { Arbeitsbereich } from './Arbeitsbereich';
import { Mitarbeiter } from './Mitarbeiter';

export class Abwesenheit {
  readonly mitarbeiter: Mitarbeiter;
  readonly arbeitsbereich: Arbeitsbereich;
  readonly grund: Abwesenheitsgrund;
  readonly dauer: number;
  readonly id?: string;

  constructor({
    mitarbeiter,
    arbeitsbereich,
    grund,
    dauer,
    id,
  }: {
    mitarbeiter: Mitarbeiter;
    arbeitsbereich: Arbeitsbereich;
    grund: Abwesenheitsgrund;
    dauer: number;
    id?: string;
  }) {
    this.arbeitsbereich = arbeitsbereich;
    this.mitarbeiter = mitarbeiter;
    this.grund = grund;
    this.dauer = dauer ?? 0;
    this.id = id;
  }
}
